import "../polyfills/findDOMNode";
import "../lib/public_path";

// jQuery setup as a separate module so window.jQuery is set during module
// evaluation, before imagesloaded/flickity check window.jQuery at import time.
import $ from "jquery";
import "../lib/jquery_globals";

import {} from "jquery-ujs";

import "jquery-ui-dist";

// Datepicker locales
import "jquery-ui/ui/i18n/datepicker-ca";
import "jquery-ui/ui/i18n/datepicker-de";
import "jquery-ui/ui/i18n/datepicker-el";
import "jquery-ui/ui/i18n/datepicker-es";
import "jquery-ui/ui/i18n/datepicker-fr";
import "jquery-ui/ui/i18n/datepicker-hr";
import "jquery-ui/ui/i18n/datepicker-it";
import "jquery-ui/ui/i18n/datepicker-nl";
import "jquery-ui/ui/i18n/datepicker-pl";
import "jquery-ui/ui/i18n/datepicker-pt";
import "jquery-ui/ui/i18n/datepicker-pt-BR";
import "jquery-ui/ui/i18n/datepicker-ru";
import "jquery-ui/ui/i18n/datepicker-zh-CN";

import "cloudinary-jquery";

// FullCalendar
import "fullcalendar/dist/fullcalendar.css";
import { Calendar } from "fullcalendar";
window.FullCalendar = Calendar;

// AOS
import AOS from "aos";
window.AOS = AOS;

// Moment
import moment from "moment";
window.moment = moment;

import "../lib/websites/jquery.daterangepicker";

// Slick carousel
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../lib/websites/flickity";
import "../lib/websites/fullscreen";
import "imagesloaded";

import "../lib/websites/bxslider";

// Styles
import "../stylesheets/be-ds.style.css";
import "../stylesheets/booking-engine.style.css";
import "@amenitiz/payment-frontend/dist/style.css";
import "jquery-ui/dist/themes/base/jquery-ui.css";

import "jquery.maskedinput/src/jquery.maskedinput";

// Bootstrap
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.css";
import "bootstrap-datepicker";
import "bootstrap-toggle";

// --- Vanilla replacements for Bootstrap JS components ---
import "../lib/dropdown";
import "../lib/tooltip";
import "../lib/modal";

// Tailwind last so its utilities win over bootstrap/jquery-ui
import "../stylesheets/tailwind.style.css";

import "../lib/confirm";

import _ from "underscore";
window._ = _;

import "../lib/websites/cloudinary-images";
import "../lib/websites/fittext";
import "../lib/websites/masonry.pkgd";

import "../lib/websites/be_header_fix";

import "../lib/websites/amenitiz";

import ReactRailsUJS from "../lib/react_rails";

if (window) window.ReactRailsUJS = ReactRailsUJS;
ReactRailsUJS.detectEvents();

$.htmlPrefilter = (html) => html;

window.setTimeout(() => {
  $(".alert").delay(2000).fadeOut(3000);
});
